module.exports = __webpack_public_path__ + "media/images/stock_groups/e325-cf265cc398e6aff353e08c8e2fd1436a.svg";